// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav {
  width: 100%;
  background-color: white;
  position: relative;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid lightgrey;
  padding: 25px;
}

.nav > .nav-header {
  display: inline;
}

.nav > .nav-header > .nav-title {
  display: inline-block;
  font-size: 22px;
  color: #fff;
  padding: 10px 10px 10px 10px;
}

.nav > .nav-btn {
  display: none;
}

.nav > .nav-links {
  display: inline;
  float: right;
  font-size: 18px;
  z-index: 100;
}

.nav > .nav-links > a {
  font-weight: 600;
  display: inline-block;
  padding: 13px 10px 13px 10px;
  text-decoration: none;
  color: #2d2d2d;
  transition: all 0.6s ease-in-out;
  -webkit-transition: all 0.6s;
  -moz-transition: all 0.6s;
  -ms-transition: all 0.6s;
  -o-transition: all 0.6s;
}

.nav > .nav-links > a:hover {
  color: var(--thm-secondary);
}

.nav > #nav-check {
  display: none;
}

@media (max-width: 600px) {
  .nav > .nav-btn {
    display: inline-block;
    position: absolute;
    right: 0px;
    top: 25px;
  }
  .nav > .nav-btn > label {
    display: inline-block;
    width: 50px;
    height: 50px;
    padding: 13px;
    cursor: pointer;
  }
  /* .nav > .nav-btn > label:hover,
    .nav #nav-check:checked ~ .nav-btn > label {
      background-color: rgba(0, 0, 0, 0.3);
    } */
  .nav > .nav-btn > label > span {
    display: block;
    width: 25px;
    height: 10px;
    border-top: 2px solid rgb(20, 18, 18);
  }
  .nav > .nav-links {
    position: absolute;
    display: block;
    width: 100%;
    background-color: #333;
    height: 0px;
    transition: all 0.3s ease-in;
    overflow-y: hidden;
    top: 50px;
    left: 0px;
  }
  .nav > .nav-links > a {
    display: block;
    width: 100%;
    color: white;
    text-align: center;
  }
  .nav > #nav-check:not(:checked) ~ .nav-links {
    height: 0px;
  }
  .nav > #nav-check:checked ~ .nav-links {
    height: calc(100vh - 50px);
    overflow-y: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/Navbar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EACd,gCAAgC;EAChC,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;EACA;;;OAGK;EACL;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,qCAAqC;EACvC;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,4BAA4B;IAC5B,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF","sourcesContent":[".nav {\r\n  width: 100%;\r\n  background-color: white;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  border-bottom: 1px solid lightgrey;\r\n  padding: 25px;\r\n}\r\n\r\n.nav > .nav-header {\r\n  display: inline;\r\n}\r\n\r\n.nav > .nav-header > .nav-title {\r\n  display: inline-block;\r\n  font-size: 22px;\r\n  color: #fff;\r\n  padding: 10px 10px 10px 10px;\r\n}\r\n\r\n.nav > .nav-btn {\r\n  display: none;\r\n}\r\n\r\n.nav > .nav-links {\r\n  display: inline;\r\n  float: right;\r\n  font-size: 18px;\r\n  z-index: 100;\r\n}\r\n\r\n.nav > .nav-links > a {\r\n  font-weight: 600;\r\n  display: inline-block;\r\n  padding: 13px 10px 13px 10px;\r\n  text-decoration: none;\r\n  color: #2d2d2d;\r\n  transition: all 0.6s ease-in-out;\r\n  -webkit-transition: all 0.6s;\r\n  -moz-transition: all 0.6s;\r\n  -ms-transition: all 0.6s;\r\n  -o-transition: all 0.6s;\r\n}\r\n\r\n.nav > .nav-links > a:hover {\r\n  color: var(--thm-secondary);\r\n}\r\n\r\n.nav > #nav-check {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .nav > .nav-btn {\r\n    display: inline-block;\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 25px;\r\n  }\r\n  .nav > .nav-btn > label {\r\n    display: inline-block;\r\n    width: 50px;\r\n    height: 50px;\r\n    padding: 13px;\r\n    cursor: pointer;\r\n  }\r\n  /* .nav > .nav-btn > label:hover,\r\n    .nav #nav-check:checked ~ .nav-btn > label {\r\n      background-color: rgba(0, 0, 0, 0.3);\r\n    } */\r\n  .nav > .nav-btn > label > span {\r\n    display: block;\r\n    width: 25px;\r\n    height: 10px;\r\n    border-top: 2px solid rgb(20, 18, 18);\r\n  }\r\n  .nav > .nav-links {\r\n    position: absolute;\r\n    display: block;\r\n    width: 100%;\r\n    background-color: #333;\r\n    height: 0px;\r\n    transition: all 0.3s ease-in;\r\n    overflow-y: hidden;\r\n    top: 50px;\r\n    left: 0px;\r\n  }\r\n  .nav > .nav-links > a {\r\n    display: block;\r\n    width: 100%;\r\n    color: white;\r\n    text-align: center;\r\n  }\r\n  .nav > #nav-check:not(:checked) ~ .nav-links {\r\n    height: 0px;\r\n  }\r\n  .nav > #nav-check:checked ~ .nav-links {\r\n    height: calc(100vh - 50px);\r\n    overflow-y: auto;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
